export const ERROR_MESSAGE_TITLE = 'Error'
export const ERROR_MESSAGE_TEXT =
  'Fund Performance information is unavailable at this time. Please try again later.'
